webpackJsonp([25],{

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(587),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-74cecef4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['edit', 'maxAllergenId'],
  data: function data() {
    return {
      err: '',
      language: this.$cookie.get('lang') || 'en',
      languages: JSON.parse(localStorage.languages),
      allergens: {
        names: [{
          language: this.$cookie.get('lang') || 'en',
          name: ''
        }]
      },
      isEdit: false
    };
  },

  methods: {
    addLang: function addLang(lang, langIndex) {
      this.allergens.names.push({
        language: lang,
        name: ''
      });
      this.languages.splice(langIndex, 1);
    },
    submit: function submit() {
      var allergen = {};
      if (!this.isEdit) {
        allergen['allergenId'] = this.maxAllergenId + 1;
      } else {
        allergen['allergenId'] = this.edit.allergen.allergenId;
      }
      allergen.name = {};
      this.allergens.names.forEach(function (entry) {
        if (entry.name !== '') {
          allergen.name[entry.language] = entry.name;
        }
      });
      if (this.isEdit) {
        var index = this.edit.index;
        this.$emit('update', {
          allergen: allergen,
          index: index
        });
      } else {
        this.$emit('submit', allergen);
      }
      this.$emit('close');
    }
  },
  created: function created() {
    var _this = this;

    if (this.edit) {
      this.isEdit = true;
      var allergen = this.edit.allergen;
      var languages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(allergen.name);
      this.allergens.names = [];
      languages.forEach(function (language) {
        var index = null;
        _this.allergens.names.push({
          language: language,
          name: allergen.name[language]
        });
        _this.languages.forEach(function (lang, i) {
          if (lang.value === language) {
            index = i;
          }
        });
        if (index !== null) {
          _this.languages.splice(index, 1);
        }
      });
    }
  }
});

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, ".err[data-v-74cecef4]{font-size:16px;padding:15px;padding-top:0}.modal[data-v-74cecef4]{display:block;background:rgba(0,0,0,.5)}.modal-body[data-v-74cecef4]{max-height:80vh;overflow-y:auto}@media (min-width:576px){.modal-dialog[data-v-74cecef4]{max-width:70%}}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/modals/AllergensModal.vue"],"names":[],"mappings":"AACA,sBACE,eAAgB,AAChB,aAAc,AACd,aAAe,CAChB,AACD,wBACE,cAAe,AACf,yBAA+B,CAChC,AACD,6BACI,gBAAiB,AACjB,eAAiB,CACpB,AACD,yBACA,+BACI,aAAe,CAClB,CACA","file":"AllergensModal.vue","sourcesContent":["\n.err[data-v-74cecef4] {\n  font-size: 16px;\n  padding: 15px;\n  padding-top: 0;\n}\n.modal[data-v-74cecef4] {\n  display: block;\n  background: rgba(0, 0, 0, 0.5);\n}\n.modal-body[data-v-74cecef4] {\n    max-height: 80vh;\n    overflow-y: auto;\n}\n@media (min-width: 576px) {\n.modal-dialog[data-v-74cecef4] {\n    max-width: 70%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(529);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("0ac6d63d", content, true, {});

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.isEdit ? 'Edit' : 'Add') + " Allergen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "column text-xs-left",
    staticStyle: {
      "width": "65px"
    },
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v("Name")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allergens.names), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "width": "65px"
      }
    }, [_vm._v(_vm._s(item.language))]), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "text",
        "value": item.name
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    })], 1)])
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": "",
      "align-center": ""
    }
  }, [(_vm.languages.length > 0) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-menu', [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "outline": "",
      "type": "button"
    },
    slot: "activator"
  }, [_vm._v("\n          Add language\n          "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(lang, index) {
    return (lang !== _vm.language) ? _c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.addLang(lang.value, index)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(lang.text) + "\n            ")])], 1) : _vm._e()
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.f2850f44c3d90136dd77.js